<template>
  <div class="container">
    <div class="row success justify-content-center m-0">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <!-- <i class="fa-regular success-icon fa-circle-check green-color"></i> -->
            <div class="text-center">
              <img src="/assets/images/icons/logo-true.png" class="logo-width" alt="">
            </div>
            <h4 class="pt-5">تم تأكيد الدفع بنجاح. نشكركم على ثقتكم</h4>
            <p class="gray-text">عملية الدفع قد تمت بنجاح، وقد تم تأكيد استلام المبلغ المطلوب. نشكركم <br> على ثقتكم ونتطلع إلى خدمتكم دائماً</p>
          </div>
        </div>

        <div class="row justify-content-center pt-3">
          <div class="col col-md-7 text-center">
            <router-link to="/">
              <div class="btn-black font-22">عودة الى الرئيسية</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'success',
}
</script>